import { Login } from "../containers/Login";

export const APIEndpoints = {
    TranscriptProxy: '/transcript/proxy',
    // Recent
    Document: 'document',
    Template:'template',
    AdminUsers: `admin-users`,
    Users: `users`,
    Languages: `languages`,
    Categories: `categories`,
    Resources: `resources`,
    Roles: `roles`,
    Menus: `menus`,
    MenuList:`menu`,
    Widgets: 'widgets',
    WidgetsItemTypes: 'widget-item-types',
    WidgetItems: 'widget-items',
    Show: `shows`,
    WidgetTypes: 'widget-types',
    Templates: 'templates',
    TemplatesTypes: 'template-types',
    Pages: 'pages',
    Settings: 'settings',
    SubscriptionHeader: 'subscription-headers',
    MonetizationStrategy: 'monetization-strategy',
    Icons: '/icons',

    // Plan Management
    Plans: 'plans',
    PlansOptions: 'plans/options',
    PlanSets: 'plan-sets',
    PlanCycles: 'plan-cycle',

    // Other
    Platform:`platform`,
    Movie: 'movies',
    Series: 'series',
    Interactivity: 'virtual-assets',
    InteractivityStatusUpdate: 'virtual-assets/update-status',
    InteractivityAssetUpdate: 'virtual-assets/update-asset-type',
    Utility: 'utility',
    Ebook: 'ebook',
    EbookStatusUpdate: 'ebook/update-status',
    BuildVersion: 'build-version',
    AppVersion: 'app-version',
    Category:'category',
    Courses:'courses',
    Events:'events',
    CachePurge: 'cache-purge',
    EbookMeta: 'ebook/meta-data',
    ExportRank: 'meta-data/export-rank',
    ImportRank: 'meta-data/import-rank',
    BulkUpload: `meta-data/bulk-meta-data-update`,
    BulkUploadOpt: 'meta-data/bulk-meta-data-update-option',
    SeriesMeta: 'episodes/series-meta',
    SeriesEpisode: "episodes/series-episode",
    Episodes: "episodes",
    GenerateLabelsFromFile: "label-gen/generate-from-file",
    GenerateLabelsFromText: "label-gen/generate-from-text",
    //ExportAllEpisodes:'export',
    ExportAllEpisodes:'export/content-mapping',
    Audio: 'audio',
    Page:'pages',
    Tray: 'tray',
    Deck: 'deck-management',
    Games: 'games',
    GameStatusUpdate: 'games/update-status',
    GameAssetUpdate: 'games/update-asset-type',
    LinearMedia: 'linear-media',
    BulkUpdate: 'audio/bulk-status-update',
    TrayOptions: 'tray/options',
    ChannelOptions: 'channel/options',
    Channel: 'channel',
    SiteSetting: 'site-settings',
    SiteConstants: `site-settings/options`,
    PermissionSubjects: '/auth/authorities',
    PopularSearch: 'popular-search',
    FirstHit: 'first-hit',
    Skills: 'skills',
    CommonSearch: 'common/search-assets',
    Report: 'meta-data/report',
    ReportOptions: 'meta-data/report-option',
    Collection : 'collections',
    Auth: {
        Login: '/auth/login',
        Refresh: '/auth/refresh',
        ForgotPassword: '/auth/forgot-password',
        ResetPassword: `/auth/reset-password`,
        ChangePassword: `/auth/change-password`
    },
    Client:'master-config',
    Sms:'sms',
    Crm:'crm',
    LoginActivity:'login-activity',
    errorLogs:'error-logs',
    Upload : 'file-upload/upload',
    PaywallTemplates: 'paywall-templates',
    Prompts: 'prompts',
    Reports: 'reports',
    DislikeReasonReport: 'reports/dislike/report',
    DislikeEpisodes: 'reports/dislike/episodes',
    DislikeExport: 'reports/dislike/export',
    RatingReport: 'reports/rating/report',
    RatingExport: 'reports/rating/export',
    VideoTrackingReport: 'reports/dashboard/video-tracking',
    VideoBufferReport: 'reports/dashboard/video-buffer',
    VideoPlayerError: 'reports/dashboard/video-errors',
    WebhookInstrument: 'reports/webhook-instrument',
    SubscriptionReport: 'reports/dashboard/subscription-report',
    SubscriptionReportExport: 'reports/dashboard/subscription-report/export',
    SubscriptionHealthStateDistribution: 'reports/subscription-health/state-distribution',
    SubscriptionHealthStateChanges: 'reports/subscription-health/state-changes',
  // SubscriptionHealthKpis: 'reports/subscription-health/kpis/v2', // legacy KPI endpoint
    SubscriptionHealthKpis: 'reports/subscription-current-report/kpis',
    SubscriptionHealthKpisExport: 'reports/subscription-current-report/export',
    VideoTrackingAppVersions: 'reports/dashboard/app-versions',
    VideoTrackingExport: 'reports/dashboard/video-tracking/export',
    AcquisitionReport: 'reports/acquisition-report',
    AcquisitionReportExport: 'reports/acquisition-report/export',
    AcquisitionRealtimeFunnel: 'reports/acquisition-report/realtime-funnel',
    AcquisitionFunnel: 'reports/acquisition-report/funnel',
    AcquisitionFunnelFilterOptions: 'reports/acquisition-report/funnel/filter-options',
    AcquisitionRealtimeFunnelExport: 'reports/acquisition-report/realtime-funnel/export',
    AcquisitionAppsflyerDailyIngest: 'reports/acquisition-report/ingest-appsflyer-daily',
    AcquisitionAppsflyerSyncInstalls: 'appsflyer/sync-installs',
    RevenueMonetizationKpi: 'reports/monetization/kpi',
    RevenueMonetizationKpiExport: 'reports/monetization/kpi/export',
    RevenueMonetizationMrr: 'reports/monetization/mrr',
    RevenueMonetizationRevenueChart: 'reports/monetization/revenue-chart',
    RevenueMonetizationPlanMix: 'reports/monetization/plan-mix',
    RevenueMonetizationLtv: 'reports/monetization/ltv',
    UserPlanReport: 'reports/user-plan',
    PaymentOrderReport: 'reports/payment-orders',
    PaymentOrderReportExport: 'reports/payment-orders/export',
    DashboardComprehensive: "/reports/dashboard/comprehensive",

    SearchCapsules: 'search-capsules',
    Contest: 'contest',
    Questions: 'questions',
    Rewards: 'rewards',
    Tools: 'tools',
    BusinessRule: 'business-rules',
    AskQuestion: 'ask-question',
    Activity: 'activity',
    CustomCheckoutTemplateConfig: 'custom-checkout-template-config',
    PaymentMethod: 'payment-method',
    PaymentFailureTemplate: 'payment-failure-template',
        // Articles
    Articles: 'articles',
    SeriesArticle: 'articles/series-article',
    ExportAllArticles: 'export/content-mapping',

}

